import { createSelector } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';
import type { RootState } from 'src/root/store';

import type { CounselorMeritBadge } from '@appTypes/esb';

const moduleSelector = (state: RootState) => state.mbcBulkAssign;

/**
 * User's selection of a merit badge
 */
export const mbSelectionSel = createSelector(
  [
    state => moduleSelector(state).mb,
    state => moduleSelector(state).counselorMB,
  ],
  (mb, counselorMB) => ({
    mb,
    counselorMB,
  }),
);

/**
 * If user selected already a Merit Badge.
 */
export const hasSelectionSel = createSelector(
  mbSelectionSel,
  state => state.counselorMB && state.mb,
);

export const selectedYouthSel = createSelector(
  moduleSelector,
  state => state.selectedYouth,
);
export const selectedYouthByMIDSel = createSelector(
  selectedYouthSel,
  youth => new Map(youth.map(item => [item.memberId, item])),
);

export const disableSubmitSel = createSelector(
  hasSelectionSel,
  selection => !selection,
);

const mbcProfileSel = createSelector(moduleSelector, state => state.mbcProfile);

export const filteredMBSel = createSelector(mbcProfileSel, mbcProfile => {
  const isValidMB = (mb: CounselorMeritBadge) => {
    // Check it's not expired
    const effectiveDt = DateTime.fromISO(mb.effectiveDt!);
    const expiryDt = DateTime.fromISO(mb.expiryDt!);
    const today = DateTime.now();
    if (effectiveDt > today) return false; // not yet effective
    if (expiryDt < today) return false; // already expired

    return true;
  };

  const filtered = (mbcProfile?.meritBadges || []).filter(mb => isValidMB(mb));

  return filtered || [];
});

export const validationErrorsSel = createSelector(
  moduleSelector,
  state => state.validationErrors,
);
